import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRedirect, useNotify, useTranslate } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import defaultTheme from 'ra-ui-materialui/lib/defaultTheme';
import { Notification } from 'ra-ui-materialui/lib/layout';
import classnames from 'classnames';
import { Avatar, Card } from '@material-ui/core';
import { requestPasswordReset, submitNewPassword } from '../../amplifyHandlers';
import { RequestResetPassword, RequestChangePassword } from './forms';
import { pageStyles } from '../styles';

const sanitizeRestProps = ({
  classes,
  className,
  location,
  title,
  array,
  theme,
  dispatch,
  staticContext,
  isLoading,
  ...rest
}) => rest;

const ForgotPassword = withStyles(pageStyles)(
  ({
    classes,
    className,
    changePasswordFormStyle,
    resetPasswordFormStyle,
    authIcon,
    ...rest
  }) => {
    const [step, setStep] = useState('request');
    const redirect = useRedirect();
    const [userEmail, setEmail] = useState(null);
    const notify = useNotify();
    const translate = useTranslate();

    const handleRequest = (form, setLoading) => {
      setLoading(true);
      return requestPasswordReset(form.email)
        .then(_ => {
          notify(
            translate('notification.auth.passwdResetSent', {
              _: 'Reset password request sent',
            }),
            'info'
          ); // Show a success message anyway for security
          setEmail(form.email);
          setLoading(false);
          return setStep('reset');
        })
        .catch(_ => {
          notify(
            translate('notification.auth.passwdResetSent', {
              _: 'Reset password request sent',
            }),
            'info'
          ); // Show a success message anyway for security
          setEmail(form.email);
          setLoading(false);
          return setStep('reset');
        });
    };

    const handleResetPassword = (form, setLoading) => {
      return submitNewPassword(userEmail, form.verificationCode, form.password)
        .then(_ => {
          redirect('/login');
          return notify(
            translate('notification.auth.passwdChanged', {
              _: 'Password changed successfully',
            }),
            'info'
          );
        })
        .catch(error => {
          setLoading(false);
          return notify(
            translate('error.auth.resetPwdFailure', {
              _: `'Unable to reset password: ${error.message}'`,
              errMsg: error.message,
            }),
            'warning'
          );
        });
    };

    return (
	<div
		className={classnames(classes.main, className)}
		{...sanitizeRestProps(rest)}
	>
		<Card className={classes.card}>
			{authIcon && (
				<div className={classes.avatar}>
					<Avatar className={classes.icon}>{authIcon}</Avatar>
				</div>
          )}
			{step === 'request' ? (
				<RequestResetPassword
					classes={resetPasswordFormStyle}
					requestReset={handleRequest}
            />
          ) : (step === 'reset' ? (
	<RequestChangePassword
		classes={changePasswordFormStyle}
		requestChangePassword={handleResetPassword}
            />
          ) : null)}
		</Card>
		<Notification/>
	</div>
    );
  }
);

ForgotPassword.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  meta: PropTypes.object,
  authIcon: PropTypes.object,
  theme: PropTypes.object,
  changePasswordFormStyle: PropTypes.object,
  resetPasswordFormStyle: PropTypes.object,
};

ForgotPassword.defaultProps = {
  className: null,
  classes: null,
  meta: null,
  authIcon: null,
  theme: defaultTheme,
  changePasswordFormStyle: null,
  resetPasswordFormStyle: null,
};

export default ForgotPassword;
